angular
    .module('app')
    .component('userExportList', {
        templateUrl: '/templates/pages/user-export/list/list.html',
        controller: 'UserExportListController',
        controllerAs: 'vm',
    });